import { UserList } from "../../../services/data-list/get-users/GetUsersResponse";

export type UserSearchDialogState = {
  userId?: string;
  userName?: string;
  userList: UserList[];
  selectedUserId?: string;
  selectedUserName?: string;
  selectedUsermlAdrs?: string;
  selectedUserRoleList?: UserRoleList[];
  isShow: boolean;
  isApply: boolean;
  notFound: boolean;
  defaultUserId?: string;
};

export type UserRoleList = {
  roleCd: string;
  roleName: string;
  cvrgCd: string;
  primFlg: string;
};

export type Option = {
  label: string;
  value: string;
  cvrgType?: string;
};

export type SpreadsheetState = {
  results: SpreadsheetRecordData[];
  stats: Stats[];
};

export type SpreadsheetRecordData = {
  idx: number;
  userId: string;
  emplyNum?: string;
  userName: string;
  mlAdrs: string;
  delFlg: string;
  userRoleList: UserRoleList[];
  userRoleListStr: string;
};

export type Stats = {
  isSelect: boolean;
};

export type PageNewState =
  | UserSearchDialogState
  | ((prevState: UserSearchDialogState) => UserSearchDialogState);
